@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Check Printing</h5>
            </div>
            <hr />
            <div class="card p-3" *ngIf="viewCheckPrinting">
                <h6>Payouts</h6>
                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <ejs-grid [dataSource]="checkPrintDateRange" [height]="300"
                            (rowSelected)="onRowSelected($event)" allowSorting='true' [sortSettings]='sortOptionsRange'>
                            <e-columns>
                                <e-column field="PayOutDate" headerText="Payout Date" textAlign="left" width="150">
                                    <ng-template #template let-data>
                                        {{ data.PayOutDate | date:'MM/dd/yyyy' }}
                                    </ng-template>
                                </e-column>
                                <e-column field="FromDate" headerText="From Date" textAlign="left" width="150">
                                    <ng-template #template let-data>
                                        {{ data.FromDate | date:'MM/dd/yyyy' }}
                                    </ng-template>
                                </e-column>
                                <e-column field="ToDate" headerText="To Date" textAlign="left" width="150">
                                    <ng-template #template let-data>
                                        {{ data.ToDate | date:'MM/dd/yyyy' }}
                                    </ng-template>
                                </e-column>
                                <e-column field="MachineName" headerText="Machine" textAlign="left"
                                    width="150"></e-column>
                                <e-column field="UserName" headerText="User" textAlign="left" width="150"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div *ngIf="!viewCheckPrinting">
                <div class="row">
                    <div class="col-lg-10 text-start mt-2">
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="d-flex flex-wrap">
                                    <span>Payout Date : </span>
                                    <span class="fw-semibold">{{this.selectedRecord.PayOutDate |
                                        date:'MM/dd/yyyy'}}</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="d-flex flex-wrap">
                                    <span>From Date : </span>
                                    <span class="fw-semibold">{{this.selectedRecord.FromDate |
                                        date:'MM/dd/yyyy'}}</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="d-flex flex-wrap">
                                    <span>To Date : </span>
                                    <span class="fw-semibold">{{this.selectedRecord.ToDate | date:'MM/dd/yyyy'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card p-3 my-2">
                    <h6>Settings</h6>
                    <div class="mt-2">
                        <div class="row align-items-start">
                            <div class="col-md-12 col-lg-6">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="form-label">Memo Text</label>
                                        <input type="text" class="form-control" placeholder="" [(ngModel)]="memoText">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label" style="visibility: hidden;">Update to All
                                            Checks</label>
                                        <button class="btn btnAS w-75 mb-2" [disabled]="disableUpdateAllcheck()"
                                            (click)="updateAllChecks()">Update to All Checks</button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <div class="row">
                                    <div class="col-md-6 col-xl-4">
                                        <label class="form-label">Starting Check #</label>
                                        <input type="text" class="form-control text-end" placeholder=""
                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                            [(ngModel)]="checkSetUpDetails.CurrentCheckNumber">
                                    </div>
                                    <div class="col-md-6 col-xl-4">
                                        <label class="form-label">Check Printing Orientation</label>
                                        <select class="form-select" [(ngModel)]="checkSetUpDetails.CheckOrientation"
                                            disabled>
                                            @for (item of printOrientationList; track $index) {
                                            <option [value]="item.Id">{{ item.Name }}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-md-6 col-xl-4">
                                        <label class="form-label" style="visibility: hidden;">Print Sample Check</label>
                                        <button class="btn btnAS w-100" (click)="printSampleCheck()">Print Sample
                                            Check</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card p-3 mt-2">
                    <h6>Checks Being Printed</h6>
                    <fieldset class="sort-fieldset">
                        <legend class="sort-legend">Sort By</legend>

                        <label class="radio-option">
                            <input type="radio" name="sortBy" value="vendorId" [(ngModel)]="sortBy"
                                (change)="onSortChange()" />
                            Vendor ID
                        </label>

                        <label class="radio-option">
                            <input type="radio" name="sortBy" value="vendorName" [(ngModel)]="sortBy"
                                (change)="onSortChange()" />
                            Vendor Name
                        </label>
                    </fieldset>

                    <div class="row">
                        <div class="col-12 text-start mt-2">
                            <ejs-grid #gridCheckVendors [dataSource]="checkPrintDetailsList" [height]="300"
                                (created)='created()' (dataBound)='dataBound($event)' [allowFiltering]="true"
                                (rowSelected)="onVendorsCheckRowSelected($event)"
                                (rowDeselected)="onVendorsCheckRowDeSelected($event)" [allowSorting]='false'
                                [selectionSettings]="selectionOptions">
                                <e-columns>
                                    <e-column type='checkbox' width='80' field="Selected" textAlign="Center"></e-column>
                                    <e-column field="AlphaNumericVendorId" headerText="Vendor ID" width="150"
                                        [allowFiltering]="true">
                                        <ng-template #headerTemplate let-column>
                                            <div class="custom-header">
                                                {{ column.headerText | wordReplace }}
                                            </div>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="VendorName" headerText="Vendor Name" width="180"
                                        [allowFiltering]="true">
                                        <ng-template #headerTemplate let-column>
                                            <div class="custom-header">
                                                {{ column.headerText | wordReplace }}
                                            </div>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="AmountToBePaid" headerText="Check Amount" width="150"
                                        textAlign="Right">
                                        <ng-template #template let-data>
                                            {{ data.AmountToBePaid | customCurrency }}
                                        </ng-template>
                                    </e-column>
                                    <e-column field="Memo" headerText="Memo" width="80" textAlign="Center"
                                        [allowSorting]="false">
                                        <ng-template #template let-data>
                                            <input type="checkbox" class="form-check-input" [(ngModel)]="data.Memo"
                                                [disabled]="!data.Selected" [checked]="data.Memo"
                                                (change)="checkMemoPrintDetailsRow($event, data)" />
                                        </ng-template>
                                    </e-column>
                                    <e-column field="MemoText" headerText="Memo Text" width="200"
                                        [allowSorting]="false">
                                        <ng-template #template let-data>
                                            <input type="text" class="form-control" [ngModel]="data.MemoText"
                                                (ngModelChange)="changeMemoTxtPrintDetailsRow($event, data)"
                                                [disabled]="!data.Memo" />
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 text-end mt-2">
                        <h5>Total Check Amount : {{getTotalCheckAmount() | currency}}</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end mt-2">
                        <ejs-tooltip id='tipCheckPrint' target="#btnCheckPrint" position='RightCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" id="btnCheckPrint" (click)="validatePrintCheck()"
                                [userPermissionHandler]="editPermissionHandlerData">Print Check</button>
                        </ejs-tooltip>
                        <button class="btn btn-orange" (click)="cancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="checkLayout" #checkLayout data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <app-ops-check-layout></app-ops-check-layout>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="printCheckM" #printCheckM data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ejs-diagram #diagramPrintCheck id="diagramPrintCheck" width="100%" height="1600px"
                        [rulerSettings]='rulerSettings' [scrollSettings]='scrollSettings' [pageSettings]='pageSettings'
                        [selectedItems]="selectedItems">
                    </ejs-diagram>
                </div>
            </div>
        </div>
    </div>
    <app-passcodeAuth></app-passcodeAuth>